<template>
  <base-widget
    ref="widget"
    :style="heightStyles"
    scrollable
    class="collateral overflow-hidden d-flex"
  >
    <template #heading>
      <!-- Header -->
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <!-- Title -->
          <base-heading class="collateral__heading__title" style="margin-left: 3px">
            {{ $t('folders.title') }}
          </base-heading>
        </div>
        <div class="d-flex">
          <!-- Search & New Folder buton -->
          <base-search
            v-model="localSearch"
            icon-position="left"
          />
          <base-button
            inverse
            nowrap
            class="d-flex"
            @click="newAlbumDialog = true"
          >
            <base-icon
              icon="plus-original"
              class="icon-plus"
            />
            <base-text
              light
              size="s"
            >
              {{ $t('folders.new') }}
            </base-text>
          </base-button>
        </div>
      </div>
      <br>
    </template>
    <div
      ref="scrollable"
      v-scrollable
      class="w-100 scrollable-folders"
      @reached-bottom="$emit('reached-bottom')"
    >
      <!-- Body -->
      <div class="album-folder__container" :class="folders.length === 0 ? 'empty_assets' : ''">
        <!-- All photos -->
        <div class="row">
          <album-folder
            class="single-image"
            value="All photos"
            :image="allFolderImage"
            :can-edit="false"
            :can-delete="false"
            @click="$emit('folder-clicked', {pk: 'all'})"
          />
          <!-- Shared collages -->
          <album-folder
            class="single-image"
            value="Shared collages"
            :image="sharedCollageImage"
            :can-edit="false"
            :can-delete="false"
            @click="$emit('folder-clicked', {pk: 'shared'})"
          />
          <!-- Everything else -->
          <template v-for="(item, index) in folders">
            <album-folder
              :key="`folder__${index}`"
              v-model="item.name"
              :folder-id="item.pk"
              :image="item.display_image"
              :can-delete="canDeleteFolder(item)"
              @click="$emit('folder-clicked', item)"
              @delete="$emit('folder-delete', item)"
              @title-change="$emit('title-change', $event)"
            />
          </template>
        </div>
      </div>
    </div>
    <base-modal
      id="newAlbumDialog"
      :show="newAlbumDialog"
      :show-footer="true"
      size="modal-md"
      title="Create Folder"
      @shown="onNewAlbumModalReady"
      @closed="newAlbumDialog = false"
    >
      <span v-hotkey="{enter: onCreateAlbum}" />
      <input
        ref="newAlbumInput"
        type="text"
        class="form-control infoldername"
        :placeholder="$t('folders.placeholder')"
      >
      <!-- v-model.trim="newAlbumName" -->
      <template #footer>
        <base-button
          inverse
          class="btn-create"
          @click="onCreateAlbum"
        >
          {{ $t('common.create') }}
        </base-button>
      </template>
    </base-modal>
  </base-widget>
</template>

<script>

import minHeightMixin from '@/components/mixins/minheight';
import AlbumFolder from './AlbumFolder';

export default {

  name: 'CollateralFolderMenu',
  components: {
    AlbumFolder,
  },
  mixins: [minHeightMixin],
  props: {
    folders: {
      type: Array,
      default: () => [],
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ref: 'widget', // Required by minHeightMixin
      localSearch: '',
      newAlbumDialog: false,
      searchTimer: null,
    };
  },
  computed: {
    allFolderImage() {
      return this.$store.state.folders.allFolderImage;
    },
    sharedCollageImage() {
      return this.$store.state.folders.sharedCollageImage;
    },
  },
  watch: {
    localSearch(newval) {
      this.cancelSearchTimer();
      if (newval.length) {
        this.setSearchTimer(newval);
      } else {
        this.$emit('search', '');
      }
      if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
        this.$mixpanel.track('Search_Album', {
          account_id: this.$store.state.account.user.user.email,
          search: newval,
        });
      }
    },
  },
  methods: {
    setSearchTimer(term) {
      this.searchTimer = window.setTimeout(() => {
        this.$emit('search', term);
      }, 500);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        window.clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
    },
    onCreate(evt) {
      const newName = evt.trim();
      if (newName !== '') {
        this.$emit('folder-create', newName);
      } else {
        this.$emit('folder-create', 'New Album');
      }
    },
    onCreateAlbum() {
      if (!this.newAlbumDialog) {
        return;
      }
      this.newAlbumDialog = false;
      const vm = this;
      const newAlbumName = this.$refs.newAlbumInput.value;
      this.$nextTick().then(() => {
        this.$mixpanel.track('create_album', {
          account_id: this.$store.state.account.user.user.email,
          album_name: newAlbumName,
        });
        vm.onCreate(newAlbumName);
      });
    },
    onNewAlbumModalReady() {
      const vm = this;
      this.$nextTick().then(() => {
        vm.$refs.newAlbumInput.focus();
      });
    },
    canDeleteFolder(item) {
      if (this.$store.state.account.user.profile.institution.mixpanel_enable) {
        this.$mixpanel.track('delete_album', {
          account_id: this.$store.state.account.user.user.email,
        });
      }
      return item.sync_target === null
      && item.pk !== 'all'
      && (this.$store.state.account.user.profile.url === item.owner
        || this.$store.getters['account/isManager']);
    },
  },
};
</script>

<style lang="scss" scoped>
.empty_assets{
  justify-content: start !important;
}

.collateral{
  &::v-deep .heading{
    padding: 1.25rem 1.25rem 0;
    background-color: transparent;
  }
  &__heading__title{
    margin-bottom: 0;
    font-family: 'Tiempos';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    line-height: 120%;
  }
}
.album-folder__container{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  gap: 14px;
  margin-left: -0.2rem;
  // margin-right: -0.5rem;
}
::v-deep .base-button{
  gap: 8px;
  width: 92px;
  height: 34px;
}
.btn-create{
  width: 73px;
  height: 36px;
  padding: 0px 15px;
}
.infoldername{
  width: 452px;
  margin-left: 8px;
}
.icon-plus{
  margin-left: -11px;
}
::v-deep .basecard--scrollable .base-widget__content{
    margin-right: unset !important;
    padding-right: unset !important;
}
::v-deep .base-button{
  margin-right: 8px !important;
}
.single-image{
  flex: 2 0 25% !important;
  max-width: 100% !important;
  @media (min-width: 992px){
    flex: 2 0 25% !important;
    max-width: 50% !important;
  }
  @media (max-width: 991px){
    flex: 3 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  @media (min-width: 768px){
    flex: 3 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  @media only screen and (min-width: 0px) and (max-width: 767px) {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}
</style>
